import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tandartsFR',
  templateUrl: './tandartsFR.component.html',
  styleUrls: ['./tandartsFR.component.css']
})
export class TandartsFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
